import { FormControl } from "react-bootstrap";
import React, { useEffect } from "react";
export default function ControllerActionRow(props) {
  const [userText, setUserText] = React.useState("");
  const [genAction, setGenAction] = React.useState("");

  useEffect(() => {
    // Update the document title using the browser API
    //console.log("Detected changes in columnList");
    //console.log("calling updatesummary");
    props.updateSummary([props.amethod], genAction);
  }, [genAction]);

  return (
    <tr key={props.ai}>
      <td key={props.ai}>{props.amethod}</td>
      <td>
        <FormControl
          as="textarea"
          placeholder="Custom action"
          value={userText}
          onChange={(e) => {
            setUserText(e.target.value);
            setGenAction(
              e.target.value.length > 0
                ? props.amethod + ": " + e.target.value
                : ""
            );
          }}
        />
      </td>
      <td>{genAction}</td>
    </tr>
  );
}
